export enum InstructionApiExceptionIds {
  NO_REASSIGN_WITH_FEEDBACK = "NO_REASSIGN_WITH_FEEDBACK"
}
